const muiDialogTitleTheme = (theme) => {
  theme.overrides.MuiDialogTitle = {
    root: {
      margin: 0,
      padding: theme.spacing(1),
    },
  };
};

export default muiDialogTitleTheme;
